import { createMetricsFactory } from 'metrics-js';
import { METRIC_NAMES } from './constants';
import { safeCallback } from '../utils';
import type { ConnectionStatus } from '../connection/connection-status';
import type { MessageType, TopicName } from 'magpie-types';

const Metrics = createMetricsFactory('magpie');

type ConnectionDimensions = {
  appName: string;
};

type MessageDimensions = ConnectionDimensions & {
  topicName: TopicName;
  messageType: MessageType;
};

export const MetricsReporter = {
  reportMessageSent: safeCallback(
    ({ appName, topicName, messageType }: MessageDimensions) => {
      Metrics.counter(METRIC_NAMES.MESSAGE_COUNT, {
        appName,
        topicName,
        messageType,
      }).increment();
    }
  ),
  reportMessageLatency: safeCallback(
    (
      { appName, topicName, messageType }: MessageDimensions,
      latency: number
    ) => {
      Metrics.timer(METRIC_NAMES.MESSAGE_LATENCY, {
        appName,
        topicName,
        messageType,
      }).update(latency);
    }
  ),
  reportValidationError: safeCallback(
    ({ appName, topicName, messageType }: MessageDimensions) => {
      Metrics.counter(METRIC_NAMES.VALIDATION_ERROR_COUNT, {
        appName,
        topicName,
        messageType,
      }).increment();
    }
  ),
  reportConnectionError: safeCallback(
    ({
      appName,
      status,
    }: ConnectionDimensions & { status: ConnectionStatus }) => {
      Metrics.counter(METRIC_NAMES.CONNECTION_ERROR_COUNT, {
        appName,
        status,
      }).increment();
    }
  ),
  reportHandshakeCompleted: safeCallback(
    ({ appName }: ConnectionDimensions, latency: number) => {
      Metrics.counter(METRIC_NAMES.HANDSHAKE_COMPLETED, {
        appName,
      }).increment();
      Metrics.timer(METRIC_NAMES.HANDSHAKE_LATENCY, { appName }).update(
        latency
      );
    }
  ),
};
